import { Preference } from 'types/User';

export const getPreferenceByGroup = ({
    preferences,
    userPreferenceGroupId,
    typeId,
}: {
    preferences: Preference[],
    userPreferenceGroupId: number,
    typeId: number
    }): Preference | undefined => {
    return preferences.find(p => 
        p.user_preference_group_id === userPreferenceGroupId && 
        p.type_id === typeId,
    );
};